import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'ts-spinner-ui',
  templateUrl: './spinner-ui.component.html',
  styleUrls: ['./spinner-ui.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonicModule],
})
export class SpinnerUiComponent {}
